@if (facility(); as facility) {
  <cca-wizard-step
    (formSubmit)="onSubmit()"
    [formGroup]="form"
    [caption]="facility?.facilityDetails?.name"
    heading="Target composition"
    data-testid="target-composition-form"
  >
    <div class="govuk-!-margin-top-9 govuk-!-width-two-thirds">
      <section>
        <h2 class="govuk-heading-m">Target calculator file</h2>

        <cca-file-input
          [downloadUrl]="getDownloadUrl"
          formControlName="calculatorFile"
          label="Upload the completed target calculator file."
          hint="Provide data for a continuous 12 month period (the baseline) closest to the 12 month period starting on 1 January 2022. The data must include the baseline energy for the eligible facility, split by fuel type, as well as the calculated improvement targets"
          [showFilesizeHint]="false"
          [accepted]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
        />
      </section>

      <section>
        <h2 class="govuk-heading-m">Energy or carbon units</h2>

        <div
          formControlName="sectorAssociationMeasurementType"
          label="Used by the sector"
          [valueTransform]="transformMeasurementType"
          cca-text-input
        ></div>

        <div
          widthClass="govuk-!-width-two-thirds"
          [options]="measurementTypeOptions"
          formControlName="measurementType"
          label="Used by the facility"
          govuk-select
        ></div>
      </section>

      <section>
        <h2 class="govuk-heading-m">Agreement composition</h2>
        <p>Target type</p>
        <p>Novem</p>
      </section>
    </div>
  </cca-wizard-step>
}

<hr class="govuk-footer__section-break govuk-!-margin-bottom-3" />
<a class="govuk-link" [routerLink]="['../../']"> Return to: Manage facilities </a>
